<div class="main-content inventory-upload-page">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}-5">
						<h4 class="card-title mb-0 d-flex align-items-center">
							<i class="material-icons inv-upload-back" (click)="back()" (keydown.enter)="back()" tabindex="0" role="button">arrow_back</i>
							<span class="ml-1">Xref cost upload</span>
						</h4>
					</div>
					<div class="card-body p-0">
						<div class="d-flex justify-content-between align-items-center flex-wrap px-3 pt-3 inv-upload-toolbar mb-1">
							<div class="mb-0 text-muted small" *ngIf="files.length">
								<span class="font-weight-bold text-dark">{{ files[0].name }}</span>
								<span *ngIf="reviewReady"> · {{ uploaddata?.length }} row(s)</span>
							</div>
							<span *ngIf="!files.length" class="small text-muted">One CSV or Excel file — processed automatically when you drop it.</span>
							<button
								mat-stroked-button
								type="button"
								class="mt-1"
								(click)="$event.preventDefault(); toggleUploadHelp()"
								(keydown.enter)="$event.preventDefault()">
								Help
							</button>
						</div>

						<div class="inv-upload-body w-100 px-3 pb-2">
							<ng-container *ngIf="!uploadHelp">
								<div *ngIf="!preview">
									<div class="row">
										<div class="col-lg-5 mb-3">
											<mat-card class="inv-upload-panel h-100">
												<mat-card-subtitle class="inv-upload-card-heading">Template</mat-card-subtitle>
												<mat-card-content>
													<p class="text-muted small mb-3">
														Update <strong>xref cost</strong> on <code>stockmaster</code>. Use your internal item number, or <strong>brand + manufacturer part</strong> to resolve the item.
													</p>
													<button mat-stroked-button type="button" (click)="downloadTemplate()" [disabled]="processing_recs">
														<mat-icon>file_download</mat-icon>
														Download template
													</button>
												</mat-card-content>
											</mat-card>
										</div>
										<div class="col-lg-7 mb-3">
											<mat-card class="inv-upload-panel h-100">
												<mat-card-subtitle class="inv-upload-card-heading">File &amp; header row</mat-card-subtitle>
												<mat-card-content>
													<p class="text-muted small mb-3">
														<strong>Header row #</strong> is the row with column headings. Data follows below. After the file loads, map columns. <strong>Pre-Process</strong> validates with the server;
														<strong>Submit Upload</strong> applies updates.
													</p>
													<mat-form-field appearance="outline" class="w-100 inv-upload-header-row-field">
														<mat-label>Header row #</mat-label>
														<input matInput type="number" min="1" [formControl]="rowNumber" />
														<mat-hint>Change and click Re-read if you adjust the sheet.</mat-hint>
													</mat-form-field>

													<div *ngIf="!processing_recs && !reviewReady">
														<ngx-dropzone
															class="inv-upload-dropzone"
															[ngClass]="'inv-upload-dropzone--' + dropzoneThemeColor"
															[multiple]="false"
															[expandable]="true"
															accept=".csv,.xlsx,.xls,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,text/plain"
															(change)="onSelect($event)">
															<ngx-dropzone-label>
																<div class="order-upload-dropzone__inner">
																	<mat-icon class="order-upload-dropzone__icon" aria-hidden="true">cloud_upload</mat-icon>
																	<span class="order-upload-dropzone__title">Drop one file here</span>
																	<span class="order-upload-dropzone__hint"
																		>CSV or Excel (.xlsx, .xls) — first sheet only.</span
																	>
																</div>
															</ngx-dropzone-label>
															<ngx-dropzone-preview *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onRemove(f)">
																<ngx-dropzone-label class="order-upload-file-label">{{ f.name }} · {{ formatFileSizeKb(f.size) }} KB</ngx-dropzone-label>
															</ngx-dropzone-preview>
														</ngx-dropzone>
														<div class="d-flex flex-wrap align-items-center mt-2" *ngIf="files.length">
															<button mat-stroked-button color="warn" type="button" class="mr-2 mb-1" (click)="clearAllFiles()" [disabled]="processing_recs">
																<mat-icon>delete_sweep</mat-icon>
																Remove file
															</button>
														</div>
													</div>

													<div *ngIf="reviewReady" class="mt-2">
														<div class="d-flex align-items-center flex-wrap inv-upload-loaded-file">
															<mat-icon class="text-success mr-1" style="font-size: 20px; width: 20px; height: 20px;">insert_drive_file</mat-icon>
															<span class="small text-dark mr-2 text-truncate" style="max-width: 280px;">{{ files[0]?.name }}</span>
															<button mat-stroked-button type="button" color="warn" class="py-0" (click)="clearAllFiles()">
																<mat-icon>close</mat-icon>
																Remove
															</button>
														</div>
														<p class="small text-muted mb-0 mt-2">Use <strong>Re-read file</strong> after changing the header row.</p>
													</div>
												</mat-card-content>
												<mat-card-actions align="end" class="pb-3 pt-0" *ngIf="files.length && !processing_recs">
													<button mat-stroked-button type="button" (click)="rereadFile()">
														<mat-icon>refresh</mat-icon>
														Re-read file
													</button>
												</mat-card-actions>
											</mat-card>
										</div>
									</div>
								</div>

								<div class="order-upload-processing text-center py-4" *ngIf="processing_recs">
									<mat-spinner diameter="48" class="order-upload-processing__spinner"></mat-spinner>
									<p class="order-upload-processing__title mt-3 mb-1">Reading file…</p>
									<p class="order-upload-processing__hint text-muted small mb-0">Parsing the spreadsheet and matching columns.</p>
								</div>

								<mat-card class="inv-upload-panel mt-2 mb-3" *ngIf="reviewReady && uploaddata?.length && !preview">
									<mat-card-subtitle class="inv-upload-card-heading">Map columns</mat-card-subtitle>
									<mat-card-content>
										<div class="alert alert-info d-flex align-items-start py-2 mb-3">
											<mat-icon class="flex-shrink-0 mr-2">auto_awesome</mat-icon>
											<div class="small mb-0">
												Map <strong>Xref cost</strong> (required). Map <strong>Item number</strong> or both <strong>Brand</strong> and <strong>Manufacturer part number</strong>. After
												<strong>Pre-Process</strong>, the preview shows <strong>Item # (system)</strong> — that value is what gets sent on submit.
											</div>
										</div>
										<div class="d-flex flex-wrap align-items-center mb-3">
											<button mat-stroked-button type="button" color="primary" (click)="suggestMappings()">
												<mat-icon>psychology</mat-icon>
												Suggest mappings
											</button>
										</div>
										<div *ngIf="mappingPreviewTotal > mappingPreviewMax" class="alert alert-secondary small py-2 mb-2">
											Showing the first {{ mappingPreviewMax }} of {{ mappingPreviewTotal }} row(s). <strong>Pre-Process</strong> uses every row.
										</div>
										<div
											class="table-responsive inv-upload-mapping-table-wrap"
											[ngClass]="'inv-upload-mapping-table-wrap--' + dropzoneThemeColor">
											<table class="table table-bordered table-sm inv-upload-mapping-table mb-0">
												<thead>
													<tr>
														<th *ngFor="let h of fileColumnsForMapping" class="inv-upload-mapping-th-title text-muted small" [attr.title]="h">
															<span class="inv-upload-mapping-th-text">{{ h }}</span>
														</th>
													</tr>
													<tr>
														<th *ngFor="let h of fileColumnsForMapping" class="inv-upload-mapping-th-select p-1">
															<div class="inv-upload-select-wrap">
																<select
																	class="inv-upload-mapping-select"
																	[ngClass]="'inv-upload-mapping-select--' + dropzoneThemeColor"
																	[ngModel]="getSystemFieldForFileHeader(h)"
																	(ngModelChange)="onFileColumnMappingChange(h, $event)"
																	[ngModelOptions]="{ standalone: true }">
																	<option value="">— Not used —</option>
																	<option
																		*ngFor="let m of mapcols"
																		[value]="m.field"
																		[disabled]="isFieldMappedToOtherHeader(m.field, h)">
																		{{ m.label }}<ng-container *ngIf="m.req"> *</ng-container>
																	</option>
																</select>
															</div>
														</th>
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let row of mappingPreviewRows">
														<td *ngFor="let h of fileColumnsForMapping" class="inv-upload-mapping-td small">{{ row[h] }}</td>
													</tr>
												</tbody>
											</table>
										</div>
									</mat-card-content>
								</mat-card>

								<mat-card class="inv-upload-panel mb-3" *ngIf="reviewReady && preview && mappeddata.length">
									<mat-card-subtitle class="inv-upload-card-heading">Preview</mat-card-subtitle>
									<mat-card-content class="p-0 pt-2 position-relative">
										<div *ngIf="preProcessing" class="inv-upload-preview-loading text-center py-5">
											<mat-spinner diameter="40"></mat-spinner>
											<p class="small text-muted mt-2 mb-0">Validating rows with the server…</p>
										</div>
										<div *ngIf="previewTableTotal > previewTableMax" class="alert alert-secondary small py-2 mx-3 mb-2">
											Showing the first {{ previewTableMax }} of {{ previewTableTotal }} row(s) for speed. Submit still updates every valid row.
										</div>
										<div class="table-responsive inv-upload-preview-wrap" [class.opacity-50]="preProcessing">
											<table class="table table-striped table-sm inv-upload-preview-table mb-0">
												<thead>
													<tr>
														<th>Status</th>
														<th *ngFor="let m of previewColumns">{{ m.label }}</th>
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let row of previewTableRows" [ngClass]="{ hasProblem: row?.problem }">
														<td class="small">
															<span *ngIf="!row.problem" class="text-success">OK</span>
															<div *ngIf="row.problem" class="text-danger" [innerHTML]="row.problem"></div>
														</td>
														<td *ngFor="let col of previewColumns">{{ row[col.field] }}</td>
													</tr>
												</tbody>
											</table>
										</div>
									</mat-card-content>
								</mat-card>
							</ng-container>

							<ng-container *ngIf="uploadHelp">
								<div class="row py-2">
									<div class="col-md-6">
										<h4 class="font-weight-bold">Columns</h4>
										<ul class="small">
											<li><strong>xrefcost</strong> — required. Reference / external catalog cost (decimal).</li>
											<li><strong>stockid</strong> — optional if you provide brand + part.</li>
											<li><strong>mfgname</strong> / brand — matches manufacturer code or name.</li>
											<li><strong>mfgpart</strong> — matches <code>product_to_manufacturer.partno</code> (or <code>stockmaster.mfgpart</code> fallback).</li>
										</ul>
									</div>
									<div class="col-md-6 mt-3 mt-md-0 border-md-left pl-md-4">
										<h4 class="font-weight-bold">Workflow</h4>
										<ol class="small">
											<li>Set <strong>Header row #</strong> if headings are not on row 1.</li>
											<li>Drop one file — it is read in the browser.</li>
											<li>Map columns, then <strong>Pre-Process</strong> to validate and resolve items.</li>
											<li>
												<strong>Submit Upload</strong> sends the resolved <strong>Item # (system)</strong> and xref cost only — brand/part from the file are not used again (standard cost and GL are unchanged).
											</li>
										</ol>
									</div>
								</div>
							</ng-container>
						</div>

						<div class="inv-upload-footer d-flex flex-wrap align-items-center justify-content-end px-3 py-3 border-top">
							<button mat-stroked-button type="button" *ngIf="reviewReady && !preview" (click)="$event.preventDefault(); backFromParse()">Back</button>

							<button
								mat-raised-button
								color="primary"
								type="button"
								*ngIf="reviewReady && !preview && uploaddata?.length"
								(click)="runPreProcess(uploaddata)"
								[disabled]="mappingForm.invalid || !canPreProcess || preProcessing">
								<mat-icon>fact_check</mat-icon>
								Pre-Process
							</button>

							<button mat-stroked-button type="button" *ngIf="preview" (click)="remap()">Back to mapping</button>

							<button
								mat-raised-button
								color="accent"
								type="button"
								*ngIf="preview && mappeddata.length"
								[disabled]="sending || preProcessing"
								(click)="submit()">
								<mat-icon>cloud_upload</mat-icon>
								Submit Upload
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
